import cn from "@utils/cn";
import { FC, useId } from "react";
import SwiperCore from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { Article, ImageElement } from "@/types";

import ArticleCard from "../ArticleListing/ArticleCard";

export interface Props {
  articles: Article[] | undefined;
  fallbackImage?: ImageElement;
}

SwiperCore.use([Pagination, Navigation]);
const DHubArticles: FC<Props> = ({ articles, fallbackImage }) => {
  const paginationId = useId();
  return (
    <div className="relative pb-xl md:pb-0">
      <div className="md:grid md:grid-cols-4 md:gap-l">
        {Array.isArray(articles) &&
          articles.map((article, i) => (
            <ArticleCard
              key={`wrapper-article-${article.articleType}-${i}`}
              article={article}
              isFirstArticle={i === 0}
              customClass={cn(i > 0 && "hidden md:flex")}
              fallbackImage={fallbackImage}
            />
          ))}
      </div>
      <Swiper
        className={`!-mr-m md:!hidden`}
        slidesPerView={1.4}
        centeredSlidesBounds={true}
        spaceBetween={24}
        pagination={{ type: "progressbar", el: `#${CSS.escape(paginationId)}` }}
        autoHeight={false}
        watchSlidesProgress={true}
      >
        {Array.isArray(articles) &&
          articles?.map((article, i) => {
            if (i >= 1) {
              return (
                <SwiperSlide key={`article-slide-${article.articleType}-${i}`}>
                  <ArticleCard article={article} isFirstArticle={i === 0} />
                </SwiperSlide>
              );
            }
          })}
      </Swiper>
      <div id={paginationId} className={`swiper-pagination-carousel absolute bottom-m z-10 text-center !top-auto !h-1 md:hidden`}></div>
    </div>
  );
};

export default DHubArticles;
